module.exports = __webpack_public_path__ + "img/lengueta.ee558a18.jpg";